<template>
  <div class="header-wrapper" ref="headerWrapper">
    <DemoBanner />
    <div v-if="this.$store.state.config.DEMO_BANNER && showDemoBanner && !runtimeDemoEnabled" class="demo-banner d-flex align-items-center justify-content-center neue">
      <div>
        <span class="demo-banner-text mr4">{{ $t('components.service.Header.2') }}</span>
        <a href="https://wallet.newreality.bond/" target="_blank" class="demo-banner-link neue">{{ $t('components.service.Header.3') }}</a>
      </div>
      <Icon @click="showDemoBanner = false" name="close" :active="false" class="demo-banner-close c20 ml10 pointer" />
    </div>
    <header @click="closeModal" class="header container-fluid" :class="{ 'company-header': $store.state.individual === 'Zentrolink' }">
      <div
        class="d-flex flex-row align-items-center justify-content-between h-100"
        :class="{ 'container-xl': !this.isMobile }"
      >
        <div class="header-left d-flex align-items-center">
          <router-link :to="'/'" class="logo" :aria-label="runtimeBrandName || undefined">
            <span v-if="this.$store.state.individual === 'Zentrolink'" class="d-flex align-items-center gap8">
              <img src="/branding/zentrolink/logo.svg" class="company-logo" :alt="runtimeBrandName">
              <span class="company-logo-name neue">{{ runtimeBrandName }}</span>
            </span>
            <span v-else class="d-flex align-items-center gap8">
              <span>
                <img
                  v-if="this.$store.state.logoMobile.img != 'mobile_logo_default.svg'"
                  :style="this.$store.state.logoMobile.style"
                  :src="this.$store.state.logoMobile.img"
                  class="logo-icon"
                />
                <img
                  v-else
                  :style="this.$store.state.logoMobile.style"
                  :src="require(`@/assets/${this.$store.state.logoMobile.img}`)"
                  class="logo-icon"
                />
              </span>
              <span v-if="this.$store.state.resize.w >= 480">
                <img
                  v-if="this.$store.state.logoTablet.img != 'tablet_logo_default.svg'"
                  :style="this.$store.state.logoTablet.style"
                  :src="this.$store.state.logoTablet.img"
                  :class="{ logo_mobile: this.isMobile }"
                />
                <img
                  v-else
                  :style="this.$store.state.logoTablet.style"
                  :src="require(`@/assets/${this.$store.state.logoTablet.img}`)"
                  :class="{ logo_mobile: this.isMobile }"
                />
              </span>
            </span>
          </router-link>

          <div v-if="!isMobile" class="header-separator"></div>
          <router-link v-if="!isMobile" :to="'/'" class="header-home">
            <Icon name="home_vs" size="c24" class="header-home__icon" />
          </router-link>
        </div>

        <div ref="menu" class="col menu height d-flex flex-row align-items-center justify-content-center">
          <template v-if="isMerchantPage && !isMobile">
            <router-link
              v-for="(item, key) in merchantMenuItems"
              :key="'merchant-' + key"
              :to="item.to"
              class="merchant-menu-item d-flex align-items-center gap8"
              :class="{ active: $route.path === item.to }"
            >
              <Icon :name="item.icon" size="c20" />
              <span class="neue fsp16 lh24">{{ item.label }}</span>
            </router-link>
          </template>
          <template v-else>
            <MenuItem
              v-for="(item, key) in this.mainMenuItems"
              :item="item"
              v-show="this.$store.state.resize.w >= 975"
              :key="key"
            />
          </template>
        </div>

        <div class="header-right d-flex flex-row align-items-center h-100">
          <div class="notification-btn" @click="showNotificationPanel">
            <Icon name="bell-dot" :active="!!$store.getters['informator/unreadNotifications'].length" class="c16" />
          </div>

          <div v-if="!isMobile" class="h-100 d-flex align-items-center position-relative">
            <div class="search-container d-flex flex-row align-items-center">
              <Icon name="search-grey" size="c16" class="search-icon" />
              <input
                id="search"
                ref="search_ref"
                v-model="searchQuery"
                class="search"
                :placeholder="$t('components.service.Header.1') + '...'"
                autocomplete="new-password"
                @input="this.filteredMenu"
              />
            </div>
            <Transition name="card-fade">
              <div class="search-results" v-show="this.searchQuery && this.searchActive">
                <router-link
                  v-for="(item, key) in this.searchResults"
                  :key="key"
                  :to="item.to"
                  class="search-results__item neue fsp14 lh20"
                >
                  {{ item.main_text }}
                </router-link>
                <span v-if="!this.searchResults.length" class="search-results__empty neue-roman fsp14 lh20">
                  {{ $t('components.service.Header.4') }}
                </span>
              </div>
            </Transition>
          </div>

          <MenuItem :item="this.userItems" type="user" :mobile="this.isMobile" />
          <MenuItem :item="this.burgerItems" type="burger" :mobile="this.isMobile" />

          <MenuItem v-if="this.isAdmin" :item="this.adminItems" type="admin-menu" :mobile="this.isMobile" />
        </div>
      </div>
    </header>
    <div class="container-fluid p-0 absh">
      <div v-if="this.$store.state.userData.antiphishing" ref="antiph" class="antiphishing py12">
        <div class="container-xl p-0">
          <div class="container-fluid p-0 position-relative d-flex align-items-center justify-content-center">
            <h5 class="antiphishing-text text-black m-0 d-flex flex-row align-items-center justify-content-center mr10">
              {{ this.$store.state.userData.antiphishing }}
            </h5>
            <Icon @click="this.$refs.antiph.remove();" :name="'close'"  class="c20 cursor-pointer" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DemoBanner from '@/components/service/DemoBanner.vue';
import { brandName } from '@/includes/branding';
import MenuItem from "@/components/service/topMenu/MenuItem.vue";
import Icon from "@/components/icons/Icon.vue";

export default {
  components: {
    DemoBanner,
    MenuItem,
    Icon,
  },
  data() {
    return {
      locale: this.$i18n.locale,
      langDefault: process.env.VUE_APP_I18N_LOCALE,
      rawMenu: [],
      mainMenuItems: [],
      burgerItems: [],
      userItems: [],
      adminItems: [],
      searchResults: [],
      menuItemWidth: 180,
      maxItems: 0,
      searchQuery: "",
      searchActive: false,
      isMobile: false,
      isAdmin: false,
      showDemoBanner: true,
    };
  },
  computed: {
    runtimeDemoEnabled() {
      return this.$store.state.runtimeEnvironment?.testEnvironmentNotice?.enabled === true;
    },
    runtimeBrandName() {
      return brandName(this.$store.state.individual);
    },
    isMerchantPage() {
      const path = this.$route.path;
      return path.startsWith('/merchant') || path === '/docs/merchant';
    },
    merchantMenuItems() {
      return [
        { icon: 'layout-dashboard', label: this.$t('components.service.Header.5'), to: '/merchant/dashboard_invoices' },
        { icon: 'store', label: this.$t('components.service.Header.6'), to: '/merchant' },
        { icon: 'file-text', label: this.$t('components.service.Header.7'), to: '/docs/merchant' },
        { icon: 'plus', label: this.$t('components.service.Header.8'), to: '/merchant/new' },
      ];
    },
  },
  watch: {
    '$route.path'() {
      this.updateMenuItems();
    },
    showDemoBanner() {
      this.$nextTick(() => this.updateHeaderOffset());
    },
  },
  mounted() {
    this.isAdmin = this.$store.state.userData.is_admin;

    this.setupEventListeners();
    this.initializeMenu();
    this.updateHeaderOffset();
    this.headerResizeObserver = new ResizeObserver(() => this.updateHeaderOffset());
    this.headerResizeObserver.observe(this.$refs.headerWrapper);
  },
  beforeUnmount() {
    this.headerResizeObserver?.disconnect();
    this.removeEventListeners();
  },
  methods: {
    updateHeaderOffset() {
      const h = this.$refs.headerWrapper?.offsetHeight || 72;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    },
    filteredMenu() {
      this.searchResults = [];
      const query = this.searchQuery.toLowerCase();
      if (!query) return;
      this.rawMenu.forEach((Item) => {
        if (Item.admin && !this.isAdmin) {
          return;
        }
        if (Array.isArray(Item.groups)) {
          this.filterGroups(Item, query);
        } else {
          return;
        }
      });
    },

    filterGroups(Item, query) {
      Item.groups.forEach((group) => {
        const checkRes = (localV) => {
          return localV.toLowerCase().includes(query);
        };
        const addUniqueResult = (result) => {

          const exists = this.searchResults.some((item) => item.to === result.to);

          if (!exists) {
            this.searchResults.push(result);
          }
        };
        let title = Item.title[this.locale] || Item.title[this.langDefault];
        let subtitle = group.subtitle[this.locale] || group.subtitle[this.langDefault];
        if (group.to) {
          if (checkRes(subtitle)) {
            addUniqueResult({ to: group.to, main_text: subtitle, sub_text: title });
          }
        } else if (group.list) {
          group.list.forEach((e) => {
            let content = e.content[this.locale] || e.content[this.langDefault];
            if (checkRes(content)) {
              let text = `${title} &rarr; ${subtitle}`;
              addUniqueResult({ to: e.to, main_text: content, sub_text: text });
            }
          });
        }
      });
    },

    setupEventListeners() {
      window.addEventListener("resize", this.handleResize);
      this.bindSearchEvents();
    },
    bindSearchEvents() {
      const el = this.$refs.search_ref;
      if (!el) return;
      el.addEventListener("focus", () => (this.searchActive = true));
      el.addEventListener("blur", () => setTimeout(() => {
        this.searchActive = false;
      }, 150));
    },
    removeEventListeners() {
      window.removeEventListener("resize", this.handleResize);
    },
    initializeMenu() {
      this.rawMenu = structuredClone(this.$store.state.menu);

      const lastMainItem = [...this.rawMenu].reverse().find(item => item.hasOwnProperty('main'));
      if (this.$store.state.userData.passport_serial.includes("Service-UserSpecial") || this.$store.state.userData.passport_serial.includes("Service-Member")
      || this.$store.state.userData.passport_serial.includes("Crypto-UserSpecial") || this.$store.state.userData.passport_serial.includes("Crypto-Member"))  {
        let aml = {
        'icon': 'shield',
        'subtitle': {[this.locale]: this.$t('components.service.Header.13')},
        'to': '#',
        'func': () => {
          this.openAMLCheck();
        }
      }
      lastMainItem['groups'].push(aml)
      }

      // Add KYC menu item for MICA-Individual users
      const serial = this.$store.state.userData.passport_serial;
      if (serial && serial.includes('MICA-Individual')) {
        const kycItem = {
          'icon': 'shield-check',
          'subtitle': {[this.locale]: 'KYC'},
          'to': '/kyc',
        };
        // Insert into user menu (avatar dropdown) after Registration data
        const userMenuItems = this.rawMenu.filter(item => item.user);
        let inserted = false;
        for (const menuItem of userMenuItems) {
          if (!menuItem.groups) continue;
          const regIndex = menuItem.groups.findIndex(g => {
            const to = (g.to || '').toLowerCase();
            return to === '/corr_info' || to === '/info_reg';
          });
          if (regIndex !== -1) {
            menuItem.groups.splice(regIndex + 1, 0, kycItem);
            inserted = true;
            break;
          }
        }
        if (!inserted) {
          for (const menuItem of userMenuItems) {
            if (menuItem.groups) {
              menuItem.groups.push(kycItem);
              break;
            }
          }
        }
      }

      this.handleResize();
    },
    openAMLCheck() {
      this.$store.commit('SIDE_PANEL_SHOW', {
        title: '',
        content: {
          component: 'AMLCheck',
          props: {}
        }
      });
    },
    handleResize() {
      this.isMobile = this.$store.state.resize.w < 975;
      this.updateMenuItems();
    },
    updateMenuItems() {
      if (!this.$refs.menu) return;

      if (this.isMobile) {
        this.userItems = this.rawMenu.filter((item) => item.user);
        this.adminItems = this.rawMenu.filter((item) => item.admin);
        this.mainMenuItems = [];

        if (this.isMerchantPage) {
          this.burgerItems = [
            {
              _merchantGroup: true,
              groups: [
                { subtitle: { [this.locale]: this.$t('components.service.Header.5') }, icon: 'layout-dashboard', to: '/merchant/dashboard_invoices' },
                { subtitle: { [this.locale]: this.$t('components.service.Header.6') }, icon: 'store', to: '/merchant' },
                { subtitle: { [this.locale]: this.$t('components.service.Header.7') }, icon: 'file-text', to: '/docs/merchant' },
                { subtitle: { [this.locale]: this.$t('components.service.Header.8') }, icon: 'plus', to: '/merchant/new' },
              ]
            },
            {
              _merchantGroup: true,
              groups: [
                { subtitle: { [this.locale]: this.$t('components.service.Header.10') }, icon: 'history', to: '/history' },
                { subtitle: { [this.locale]: this.$t('components.service.Header.11') }, icon: 'headset', to: '/support' },
                { subtitle: { [this.locale]: this.$t('components.service.Header.12') }, icon: 'user-search', to: '/Corr_info' },
                ...(this.$store.state.userData.passport_serial && this.$store.state.userData.passport_serial.includes('MICA-Individual') ? [{ subtitle: { [this.locale]: 'KYC' }, icon: 'shield-check', to: '/kyc' }] : []),
                { subtitle: { [this.locale]: this.$t('components.service.Header.13') }, icon: 'shield', to: '#', func: () => { this.openAMLCheck(); } },
              ]
            },
          ];
        } else {
          this.burgerItems = this.rawMenu.filter((item) => !item.user && !item.admin);
        }
      } else {
        this.maxItems = Math.floor(this.$refs.menu.clientWidth / this.menuItemWidth);
        const mainItems = this.rawMenu.filter((item) => item.main);
        this.userItems = this.rawMenu.filter((item) => item.user);
        this.mainMenuItems = mainItems.slice(0, this.maxItems);
        this.burgerItems = [
          ...mainItems.slice(this.maxItems),
          ...this.rawMenu.filter((item) => !item.main && !item.user && !item.admin),
        ];
        this.adminItems = this.rawMenu.filter((item) => item.admin);
      }
    },
    closeModal() {
      if(this.$store.state.modal.type) {
        this.$store.commit('MODAL', {
          action: false,
          type: false,
          content: false,
        });
        this.$store.commit('DARK_WRAPPER', false);
      }
    },
    showNotificationPanel() {
      this.$store.commit('SIDE_PANEL_SHOW', {
        title: this.$t('components.service.Header.9'),
        content: {
          component: 'NotificationPanel',
          props: {}
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.demo-banner {
  background: $color-yellow-2;
  padding: 10px 24px;
  font-family: "Nunito", sans-serif;
  font-size: 16px;
  color: white;

  &-link {
    color: white;
    text-decoration: underline;
    text-wrap: nowrap;
    cursor: pointer;

    &:hover {
      text-decoration: none;
    }
  }
}

.header-wrapper {
  position: sticky;
  z-index: 9000; 
  top: 0;
}

.header {
  height: 72px;
  background-color: $menu-bg;
}

.header-left {
  gap: 32px;
  flex-shrink: 0;
}

.logo {
  max-width: 400px;
  height: auto;
  min-width: 0;
}

.logo-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.logo_mobile {
  @extend .logo;
  max-width: 130px;
}

.header-separator {
  width: 1px;
  height: 30px;
  background-color: $menu-base;
  opacity: 0.2;
}

.header-home {
  display: flex;
  align-items: center;
}

.header-home__icon {
  :deep(.base_fill),
  :deep(.active_fill) {
    fill: #fff;
  }
  :deep(.base_stroke),
  :deep(.active_stroke) {
    stroke: #fff;
  }
}

.search-icon {
  :deep(.base_fill),
  :deep(.active_fill) {
    fill: rgba(#fff, 0.6);
  }
  :deep(.base_stroke),
  :deep(.active_stroke) {
    stroke: rgba(#fff, 0.6);
  }
}

.menu {
  height: 100%;
  gap: 48px;
}

.header-right {
  gap: 12px;
  flex-shrink: 0;
}

.merchant-menu-item {
  color: #fff;
  opacity: 0.6;
  text-decoration: none;
  white-space: nowrap;
  transition: opacity 0.2s ease;

  :deep(.base_fill),
  :deep(.active_fill),
  :deep(.white_fill) {
    fill: #fff;
  }

  :deep(.base_stroke),
  :deep(.active_stroke) {
    stroke: #fff;
  }

  &:hover,
  &.active {
    opacity: 1;
    color: #fff;
    text-decoration: none;
  }
}

.search-container {
  position: relative;
  background: rgba($bg-light-blue, 0.2);
  border-radius: 8px;
  padding: 10px 16px 10px 12px;
  height: 40px;
  width: 192px;
  gap: 8px;
}

.search {
  font-family: "HelveticaNeue roman";
  font-size: 14px;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  width: 100%;
}
.search.search::placeholder {
  color: rgba(255, 255, 255, 0.6);
  opacity: 1;
}

// Стили для AML Check пункта меню
.aml-check-item {
  height: 100%;
  padding: 0 15px;
  color: $menu-base;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.2s ease;
  
  &:hover {
    color: $menu-active;
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  .menu-item-text {
    white-space: nowrap;
  }
}

.antiphishing {
  background-color: $color-antiphishing;
  font-size: 1rem;
  width: 100%;
  z-index: 0;
  text-align: center;
  border-bottom: 1px solid $antiphishing-border;
  &-text {
    font-size: 16px;
  }
}

.card-fade-enter-active,
.card-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.card-fade-enter-from,
.card-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

.card-fade-enter-to,
.card-fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.search-results {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 192px;
  max-height: 300px;
  overflow-y: auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
  padding: 4px;
  z-index: 100;

  @media (max-width: 460px) {
    position: fixed;
    left: 12px;
    right: 12px;
    top: var(--header-offset, 72px);
    width: auto;
  }
}

.search-results__empty {
  display: block;
  padding: 6px 8px;
  color: $secondary-grey;
}

.search-results__item {
  display: block;
  padding: 6px 8px;
  border-radius: 4px;
  color: #000;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background: $bg-light-blue;
    color: #000;
  }
}
::-webkit-scrollbar {
  width: 5px;
  margin-right: -5px;
  background: $menu-bg;
}
::-webkit-scrollbar-thumb {
  background: $menu-active;
  border-radius: 10px;
}

.notification-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background-color: rgba($bg-light-blue, 0.2);
  border-radius: 8px;
  cursor: pointer;
  flex-shrink: 0;
}


// Company navigation follows the white official site header. Keep every
// selector inside Zentrolink so independent customer themes are unchanged.
.company-header {
  background: #fff;
  border-bottom: 1px solid #E5E7EB;
  box-shadow: 0 1px 3px rgba(17, 24, 39, .04);
  color: #111827;
  .company-logo { width: 174px; height: 32px; display: block; object-fit: cover; object-position: left; }
  // The official logo is a static wordmark and can't reflect a runtime
  // brand.json rename, so the display name stays visible in text next to it.
  .company-logo-name {
    color: #111827;
    font-size: 15px;
    font-weight: 700;
    max-width: min(320px, 45vw);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .header-left { gap: 20px; }
  .header-separator { background: #D1D5DB; opacity: 1; }
  .menu { gap: 28px; }
  .search-container, .notification-btn { background: #F3F4F6; }
  .search { color: #111827; }
  .search.search::placeholder { color: #6B7280; }
  .merchant-menu-item { color: #4B5563; opacity: 1; }
  .merchant-menu-item:hover, .merchant-menu-item.active { color: var(--brand-accent-link); }
  :deep(.menu_item), :deep(.burger_menu_item), :deep(.user_menu_item) { color: #374151; opacity: 1; }
  :deep(.menu_item:hover), :deep(.menu_item.active) { color: var(--brand-accent-link); }
  :deep(.burger_icon) { opacity: 1; }
  :deep(.menu_title_row .base_fill), :deep(.menu_title_row .active_fill),
  :deep(.burger_icon .base_fill), :deep(.burger_icon .active_fill),
  .header-home__icon :deep(.base_fill), .header-home__icon :deep(.active_fill),
  .search-icon :deep(.base_fill), .search-icon :deep(.active_fill),
  .notification-btn :deep(path[fill="white"]) { fill: #4B5563; }
  :deep(.menu_title_row .base_stroke), :deep(.menu_title_row .active_stroke),
  :deep(.burger_icon .base_stroke), :deep(.burger_icon .active_stroke),
  .header-home__icon :deep(.base_stroke), .header-home__icon :deep(.active_stroke),
  .search-icon :deep(.base_stroke), .search-icon :deep(.active_stroke) { stroke: #4B5563; }
  .merchant-menu-item :deep(.base_fill), .merchant-menu-item :deep(.active_fill),
  .merchant-menu-item :deep(.white_fill) { fill: currentColor; }
  .merchant-menu-item :deep(.base_stroke), .merchant-menu-item :deep(.active_stroke) { stroke: currentColor; }
  :deep(.card-box__title), :deep(.card-user-name), :deep(.mob-menu-item__title) { color: #111827; }
  :deep(.card-box__desc) { color: #6B7280; }
  @media (max-width: 1199px) { .menu { gap: 16px; } .header-left { gap: 16px; } }
  @media (max-width: 479px) { .company-logo { width: 152px; height: 28px; } .company-logo-name { font-size: 13px; } .header-right { gap: 8px; } }
}
</style>
